import { createApi } from '@reduxjs/toolkit/query/react';
import { oneBoxV2FetchBase } from '~/api/baseFetch';
import {
  TOneBoxV2GetNotificationImageDetail,
  TOneBoxV2GetNotificationMessageDetail,
  TOneBoxV2GetSemesters,
} from '~/api/oneBoxV2/oneBoxV2.type';
import { APIResponse } from '~/api/baseFetch/common.type';

export const oneBoxV2Api = createApi({
  reducerPath: 'oneBoxV2Api',
  baseQuery: oneBoxV2FetchBase,
  endpoints: builder => ({
    getNotificationImages: builder.query<
      APIResponse<TOneBoxV2GetNotificationImageDetail[]>,
      void
    >({
      query: () => ({
        url: '/notificationImages/post',
      }),
    }),
    getNotificationMessages: builder.query<
      APIResponse<TOneBoxV2GetNotificationMessageDetail[]>,
      void
    >({
      query: () => ({
        url: '/notificationTexts/post',
      }),
    }),
    getSemesters: builder.query<APIResponse<TOneBoxV2GetSemesters[]>, void>({
      query: () => ({
        url: `/semesters?time=${new Date().toISOString()}`,
      }),
    }),
  }),
});

export const {
  useGetNotificationImagesQuery,
  useGetNotificationMessagesQuery,
  useGetSemestersQuery,
  useLazyGetNotificationImagesQuery,
  useLazyGetNotificationMessagesQuery,
  useLazyGetSemestersQuery,
} = oneBoxV2Api;
